import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { useEffect, useState } from "react";
import { Alert } from "components/bootstrap";
import Spinner from "components/common/Spinner";
import zIndices from "theme/z-indices";
import Delayed from "./Delayed";
const Container = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.global.contentBackground};
    position: fixed;
    min-width: 200px;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
    z-index: ${zIndices.indicator};
  `
);
const StyledAlert = styled(Alert)`
  margin: 0;
  height: 32px;
  padding: 5px 20px;
  text-align: center;
`;
const LoadingIndicator = ({ text = void 0, longWaitText = void 0, longWaitTimeout = 2e4 }) => {
  const { t } = useTranslation("common");
  const [isLongWait, setIsLongWait] = useState(false);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsLongWait(true);
    }, longWaitTimeout);
    return () => clearTimeout(timeoutId);
  }, [longWaitTimeout]);
  const indicatorText = isLongWait ? longWaitText != null ? longWaitText : t("loading_long_wait") : text != null ? text : t("loading");
  return /* @__PURE__ */ React.createElement(Delayed, { delay: 500 }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement(Spinner, { delay: 0, text: indicatorText }))));
};
export default LoadingIndicator;
